(function() {
  const buyBox = document.querySelector('.mn-buy-box');
  if (!buyBox) return;

  const tabs = buyBox.querySelectorAll('.mn-buy-box__tab');
  const contents = buyBox.querySelectorAll('.mn-buy-box__content');
  const form = buyBox.querySelector('.mn-buy-box__form');
  const variantInput = form.querySelector('[data-variant-input]');
  const quantityInput = form.querySelector('[data-quantity-input]');
  const sellingPlanInput = form.querySelector('[data-selling-plan-input]');
  const cartPrice = form.querySelector('[data-cart-price]');
  const cartPriceOld = form.querySelector('[data-cart-price-old]');
  const addToCartComponent = form.closest('add-to-cart-component');

  let currentTab = 'subscribe';
  let selectedVariantId = variantInput.value;
  let selectedQuantity = 1;
  let selectedSellingPlan = null;

  // Tab switching
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const tabType = this.dataset.tab;
      
      tabs.forEach(t => {
        t.classList.remove('mn-buy-box__tab--active');
        t.setAttribute('aria-pressed', 'false');
      });
      
      contents.forEach(c => {
        c.classList.remove('mn-buy-box__content--active');
      });
      
      this.classList.add('mn-buy-box__tab--active');
      this.setAttribute('aria-pressed', 'true');
      
      const targetContent = buyBox.querySelector(`.mn-buy-box__content[data-content="${tabType}"]`);
      if (targetContent) {
        targetContent.classList.add('mn-buy-box__content--active');
      }
      
      currentTab = tabType;
      
      // Reset selection for the new tab
      const firstOption = targetContent.querySelector('.mn-buy-box__option');
      if (firstOption) {
        selectOption(firstOption);
      }
    });
  });

  // Option selection
  function selectOption(optionElement) {
    const parentContent = optionElement.closest('.mn-buy-box__content');
    const allOptions = parentContent.querySelectorAll('.mn-buy-box__option');
    
    allOptions.forEach(opt => {
      opt.classList.remove('mn-buy-box__option--active');
      opt.setAttribute('aria-checked', 'false');
      const input = opt.querySelector('input[type="radio"]');
      if (input) input.checked = false;
    });
    
    optionElement.classList.add('mn-buy-box__option--active');
    optionElement.setAttribute('aria-checked', 'true');
    
    // Check the radio input
    const radioInput = optionElement.querySelector('input[type="radio"]');
    if (radioInput) radioInput.checked = true;
    
    if (currentTab === 'onetime') {
      selectedVariantId = optionElement.dataset.variantId;
      selectedQuantity = parseInt(optionElement.dataset.quantity) || 1;
      selectedSellingPlan = null;
      
      variantInput.value = selectedVariantId;
      quantityInput.value = selectedQuantity;
      sellingPlanInput.value = '';
    } else {
      // Subscribe & Save: always use 1 pack variant, quantity = products to add (6, 3, or 1)
      selectedVariantId = optionElement.dataset.variantId;
      selectedSellingPlan = optionElement.dataset.sellingPlanId;
      selectedQuantity = parseInt(optionElement.dataset.quantity) || 1;
      
      variantInput.value = selectedVariantId;
      quantityInput.value = selectedQuantity;
      sellingPlanInput.value = selectedSellingPlan;
    }
    
    updateCartButton();
  }

  // Add click handlers to all options
  const allOptions = buyBox.querySelectorAll('.mn-buy-box__option');
  allOptions.forEach(option => {
    option.addEventListener('click', function() {
      selectOption(this);
    });
    
    option.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        selectOption(this);
      }
    });
  });

  // Update cart button prices
  function updateCartButton() {
    const activeOption = buyBox.querySelector('.mn-buy-box__content--active .mn-buy-box__option--active');
    if (!activeOption) return;
    
    if (currentTab === 'onetime') {
      // For one-time purchase, use variant data
      const variantPrice = parseFloat(activeOption.dataset.variantPrice);
      const variantComparePrice = parseFloat(activeOption.dataset.variantComparePrice);
      
      cartPrice.textContent = formatMoney(variantPrice);
      
      if (variantComparePrice && variantComparePrice > variantPrice) {
        cartPriceOld.textContent = formatMoney(variantComparePrice);
        cartPriceOld.style.display = '';
      } else {
        cartPriceOld.style.display = 'none';
      }
    } else {
      const sellingPlanPrice = parseFloat(activeOption.dataset.sellingPlanPrice);
      const sellingPlanComparePrice = parseFloat(activeOption.dataset.sellingPlanComparePrice);
      
      cartPrice.textContent = formatMoney(sellingPlanPrice);
      
      if (sellingPlanComparePrice && sellingPlanComparePrice > sellingPlanPrice) {
        cartPriceOld.textContent = formatMoney(sellingPlanComparePrice);
        cartPriceOld.style.display = '';
      } else {
        cartPriceOld.style.display = 'none';
      }
    }
  }

  // Format money using Shopify's money format
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = parseFloat(cents);
    const moneyFormat = window.buyBoxMoneyFormat || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    
    if (moneyFormat.includes('amount_no_decimals')) {
      return moneyFormat.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    } else if (moneyFormat.includes('amount_with_comma_separator')) {
      return moneyFormat.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
    } else if (moneyFormat.includes('amount')) {
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
    }
    
    // Fallback
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  // Initialize with first option selected
  const firstActiveOption = buyBox.querySelector('.mn-buy-box__content--active .mn-buy-box__option--active');
  if (firstActiveOption) {
    selectOption(firstActiveOption);
  }

  // Modal functionality
  const modalTriggers = document.querySelectorAll('.mn-buy-box__modal-trigger');
  const modal = document.querySelector('.mn-buy-box__modal');
  const modalOverlay = modal ? modal.querySelector('.mn-buy-box__modal-overlay') : null;
  const modalClose = modal ? modal.querySelector('.mn-buy-box__modal-close') : null;

  if (modalTriggers.length > 0 && modal) {
    // Open modal - attach to all trigger buttons
    modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      });
    });

    // Close modal on overlay click
    if (modalOverlay) {
      modalOverlay.addEventListener('click', function() {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      });
    }

    // Close modal on close button click
    if (modalClose) {
      modalClose.addEventListener('click', function() {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      });
    }

    // Close modal on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.style.display === 'flex') {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  }
})();